import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const externalApi = createApi({
  reducerPath: "externalApi",
  baseQuery: fetchBaseQuery({
    // baseUrl: "https://101d-bankapi-prod.s3.amazonaws.com/defaults/",
    baseUrl: "/",
  }),
  endpoints: (builder) => ({
    getPayees: builder.query<
      {
        name: string;
        accountNumber: string;
        bankBranchId: string;
        userId: string;
        isDefaultEmployee?: boolean;
      }[],
      void
    >({
      query: () => "payees.json",
    }),
  }),
});

export const { useGetPayeesQuery } = externalApi;
